exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label {\r\n    margin-bottom: 0.05rem;\r\n}\r\n\r\n.form-control{\r\n    padding: 0.175rem 0.75rem;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/buffer-graph/components/change-buffer.component/change-buffer.component.css
// module id = ./src/app/buffer-graph/components/change-buffer.component/change-buffer.component.css
// module chunks = main